import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _objectWithoutProperties from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
var _excluded = ["language"];
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import { computed, defineComponent, ref } from "vue";
import UserModule from "@/store/modules/user";
import CustomersModule from "@/store/modules/customers";
import { dialogVisibleForStatus, hideDialog } from "@/utils/vue-helpers/modal";
import { convertIdToCodeLang } from "@/utils/helpers/lang";
import NotificationService from "@/services/notification.service";
import { toggleModalVisible } from "@/utils/vue-helpers/modal";
import { ModalStatus } from "@/constants/modal";
import BookingModule from "@/store/modules/booking";
import { LogService } from "@/services/logging";
export default defineComponent({
  name: "CustomerEdit",
  setup: function setup() {
    var modalVisibility = dialogVisibleForStatus(ModalStatus.EditCustomer);
    var customerEditForm = ref();
    var isLoading = ref(false);
    var maxHeight = "50vh";
    var saveAndAssign = ref(false);

    var onSave = function onSave() {
      if (!customerEditForm.value) return;
      isLoading.value = true;
      customerEditForm.value.form.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(valid) {
          var _customerEditForm$val, language, data, params, customer, country, email, firstName, lastName, phone, id, company, address, allergies, title, zipCode, emailMarketingOrganiser, birthDate, city, selectedCustomer, selectedCustomerId, _customerEditForm$val2, _country, _email, _firstName, _lastName, _phone, _id, _company, _address, _allergies, _language, _title, _zipCode, _emailMarketingOrganiser, _birthDate, _city, cust;

          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!valid) {
                    _context.next = 27;
                    break;
                  }

                  _customerEditForm$val = customerEditForm.value.ruleForm, language = _customerEditForm$val.language, data = _objectWithoutProperties(_customerEditForm$val, _excluded);
                  params = _objectSpread(_objectSpread({
                    groupId: UserModule.getUserGroupId,
                    customerId: CustomersModule.editedCustomer[0].id
                  }, data), {}, {
                    language: convertIdToCodeLang(language)
                  });
                  LogService.info("Patching the customer: ", {
                    params: params
                  });
                  _context.next = 6;
                  return CustomersModule.patchCustomer(params);

                case 6:
                  customer = _context.sent;
                  country = customer.country, email = customer.email, firstName = customer.firstName, lastName = customer.lastName, phone = customer.phone, id = customer.id, company = customer.company, address = customer.address, allergies = customer.allergies, title = customer.title, zipCode = customer.zipCode, emailMarketingOrganiser = customer.emailMarketingOrganiser, birthDate = customer.birthDate, city = customer.city;
                  _context.next = 10;
                  return CustomersModule.setEditedCustomers([{
                    country: country,
                    email: email,
                    fullName: "".concat(firstName, " ").concat(lastName),
                    phone: phone,
                    id: String(id),
                    checkOrder: true,
                    company: company,
                    address: address,
                    allergies: allergies,
                    title: title,
                    zipCode: zipCode,
                    emailMarketingOrganiser: emailMarketingOrganiser,
                    birthDate: birthDate,
                    language: language,
                    city: city
                  }]);

                case 10:
                  // If the customer we have just edited is assigned to the booking we need to reassign him with his new values
                  selectedCustomer = CustomersModule.selectedCustomers.find(function (c) {
                    return c.bookingUuid === BookingModule.selectedBookingUUID;
                  });

                  if (!selectedCustomer) {
                    _context.next = 17;
                    break;
                  }

                  selectedCustomerId = selectedCustomer.id;

                  if (!(customerEditForm.value.ruleForm.id === selectedCustomerId)) {
                    _context.next = 17;
                    break;
                  }

                  // we first remove the selected customer then we reassigned the customer with the new changes
                  CustomersModule.removeSelectedCustomer(selectedCustomer);
                  _context.next = 17;
                  return CustomersModule.setSelectedCustomers([{
                    country: country,
                    email: email,
                    fullName: "".concat(firstName, " ").concat(lastName),
                    phone: phone,
                    id: String(id),
                    checkOrder: true,
                    bookingUuid: BookingModule.selectedBookingUUID,
                    company: company,
                    address: address,
                    allergies: allergies,
                    language: language,
                    title: title,
                    zipCode: zipCode,
                    emailMarketingOrganiser: emailMarketingOrganiser,
                    birthDate: birthDate,
                    city: city
                  }]);

                case 17:
                  if (!(saveAndAssign.value === true)) {
                    _context.next = 23;
                    break;
                  }

                  _customerEditForm$val2 = customerEditForm.value.ruleForm, _country = _customerEditForm$val2.country, _email = _customerEditForm$val2.email, _firstName = _customerEditForm$val2.firstName, _lastName = _customerEditForm$val2.lastName, _phone = _customerEditForm$val2.phone, _id = _customerEditForm$val2.id, _company = _customerEditForm$val2.company, _address = _customerEditForm$val2.address, _allergies = _customerEditForm$val2.allergies, _language = _customerEditForm$val2.language, _title = _customerEditForm$val2.title, _zipCode = _customerEditForm$val2.zipCode, _emailMarketingOrganiser = _customerEditForm$val2.emailMarketingOrganiser, _birthDate = _customerEditForm$val2.birthDate, _city = _customerEditForm$val2.city;
                  cust = {
                    country: _country,
                    email: _email,
                    firstName: _firstName,
                    lastName: _lastName,
                    phone: _phone,
                    id: _id,
                    company: _company,
                    address: _address,
                    allergies: _allergies,
                    language: _language,
                    title: _title,
                    zipCode: _zipCode,
                    emailMarketingOrganiser: _emailMarketingOrganiser,
                    birthDate: _birthDate,
                    city: _city
                  };
                  LogService.info("Assigning the customer: ", {
                    cust: cust
                  });
                  _context.next = 23;
                  return CustomersModule.setSelectedCustomers([{
                    country: _country,
                    email: _email,
                    fullName: "".concat(_firstName, " ").concat(_lastName),
                    phone: _phone,
                    id: String(_id),
                    checkOrder: true,
                    bookingUuid: BookingModule.selectedBookingUUID,
                    company: _company,
                    address: _address,
                    allergies: _allergies,
                    language: _language,
                    title: _title,
                    zipCode: _zipCode,
                    emailMarketingOrganiser: _emailMarketingOrganiser,
                    birthDate: _birthDate,
                    city: _city
                  }]);

                case 23:
                  isLoading.value = false;
                  hideDialog();
                  _context.next = 29;
                  break;

                case 27:
                  isLoading.value = false;
                  NotificationService.showCommonWarningValidation();

                case 29:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    };

    var customerModalStatus = ModalStatus.Customers;
    var isSelectedCustomer = computed(function () {
      return CustomersModule.selectedCustomers && CustomersModule.selectedCustomers.length && CustomersModule.editedCustomer && CustomersModule.editedCustomer.length && CustomersModule.editedCustomer[0].email === CustomersModule.selectedCustomers[0].email;
    });
    return {
      modalVisibility: modalVisibility,
      customerEditForm: customerEditForm,
      toggleModalVisible: toggleModalVisible,
      isLoading: isLoading,
      onSave: onSave,
      maxHeight: maxHeight,
      customerModalStatus: customerModalStatus,
      saveAndAssign: saveAndAssign,
      isSelectedCustomer: isSelectedCustomer
    };
  }
});